import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { UserService } from '../../services/user.service';
import { UpaegService } from '../../services/upaeg.service';
import { SolicitudesService } from '../../services/solicitudes.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConfirmPopComponent} from '../confirm-pop/confirm-pop.component';
import {AlertPopComponent} from '../alert-pop/alert-pop.component';

import {environment} from '../../../environments/environment';
declare let gtag: (property: string, value: any, configs: any) => {};

@Component({
  selector: 'app-mis-upaegs',
  templateUrl: './mis-upaegs.component.html',
  styleUrls: ['./mis-upaegs.component.css'],
  providers: [UserService, UpaegService, SolicitudesService]
})
export class MisUpaegsComponent implements OnInit {
  public fisicas: any;
  public morales: any;
  public grupos: any;
  public solicitantesDispo: any;
  public validada: boolean;
  public canDesvincular: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private upaegService : UpaegService,
    private solicitudService: SolicitudesService,
    public dialog: MatDialog
  ) {
    this.fisicas = null;
    this.morales = null;
    this.grupos = null;
    this.solicitantesDispo = [];
    this.canDesvincular = false;

    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        gtag('config', environment.googleAnalyticsId, {
          page_path: event.urlAfterRedirects
        });
      }
    });


   }

  ngOnInit() {
    /* VALIDATE SESSION */
    if (this.userService.getToken()){
      this.userService.check_session().subscribe(response => {
        if (response.status) {
        } else {
          this.userService.destroy_session();
          this.router.navigate(['/login']);
        }
      }, error => {
        console.log(error);
        this.userService.destroy_session();
        this.router.navigate(['/login']);
      });
    }else{
      this.userService.destroy_session();
      this.router.navigate(['/login']);
    }
   /* VALIDATE SESSION */

   this.watchMyUpaegs();
   this.getSolicitantesAperturados();
  }

  alertDialog(title, text, action): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }


  watchMyUpaegs() {
    this.upaegService.getMyUpaegs().subscribe(result => {
      console.log(result);
      console.log('De wathc upaegs');
      if (result.status) {
        this.canDesvincular = result.desvincula_upaeg;
        this.fisicas = result.fisicas;
        this.morales = result.morales;
        this.grupos = result.grupos;
        this.validada = result.validado;
      }
    }, error => {
        console.log(error);
        this.alertDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
    });
  }


  havePresolicitudes(idProductor){
    console.log(idProductor);
    this.solicitudService.getPresolUpaeg(idProductor).subscribe(response => {
      console.log(response);
      if(response.status){
        return true;
      }else{
        return false;
      }
    }, error => {
      console.log(error);
      return false;
    });

  }


  getSolicitantesAperturados (){
    this.solicitudService.getTiposSolicitantesAperturados().subscribe(response => {
      console.log(response);
      if(response.status){
        response.solicitantes.forEach(tipoSoli => {
          this.solicitantesDispo.push(tipoSoli.id_tipo_solicitante);

        });
        //this.solicitantesDispo = response.solicitantes;
        console.log(this.solicitantesDispo);

      }else{
        console.log('No hay aperturados');
      }
    }, error => {
      console.log(error);
      this.alertDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
    });

  }


  alertDialogRedirect(title, text, action): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate(['/home']);
    });
  }

  //$router->get('get/solicitudes/tipos_solicitantes', 'SolicitudesController@getTiposSolicitanteCanRegSolicitudes');


  devinculate(idProductor) {
    console.log('accion desvincular');
    const dialogRef = this.dialog.open(ConfirmPopComponent, {
      width: '40%',
      data: {
        titulo: 'Confirmación',
        texto: '¿Desea desvincular la unidad de producción de su cuenta?',
        confirm: 'Desvincular',
        cancel: 'Cancelar'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let parametros = {idProductor};
        this.upaegService.devinculateUpaeg(parametros).subscribe(response => {
          if (response.status) {
            this.alertDialogRedirect('Desvinculado', response.message, 'Cerrar');
          } else {
            this.alertDialog('Error', response.message, 'Cerrar');
          }
        }, error => {
          console.log(error);
          this.alertDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
        });
      }
    });



  }


}
